<template lang="pug">
  panel(:title='$t("ui.game_rules")')
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Live22 slot games' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text For any single progressive jackpot payout exceeding MYR 100,000 (THB 1,000,000), Company will bear the cost of the full amount.
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Joker slot games' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text Except below game, all "GRAND" jackpot, Company will bear the cost of the amount. Other type jackpot follow position taking.
      b-card-text In-game Jackpot (bonus feature)
      b-list-group.col-5
        b-list-group-item 1. Black Beard Legacy (海盗传奇)
        b-list-group-item 2. Dragon Of The Eastern Sea (东海龙王)
        b-list-group-item 3. Journey To The West (西游记)
        b-list-group-item 4. Wild Fairies (仙女百搭)
        b-list-group-item 5. OngBak (拳击)
        b-list-group-item 6. Thug Life (玩命之徒)
        b-list-group-item 7. Fortune Festival (財富佳節)
        b-list-group-item 8. Lucky Streak (幸运条纹)
        b-list-group-item 9. Ocean Spray (海洋浪花)
        b-list-group-item 10. Cyber Race (网络竞赛)
        b-list-group-item 11. Gold Trail(黃金獵者)
        b-list-group-item 12. Golden Dragon (金龍發發)
        b-list-group-item 13. Ancient Rome (古罗马)
        b-list-group-item 14. Streets Of Chicago (芝加哥街头)
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Pragmatic Play (PP) slot games' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text Not available bear on any single progreesive jackpot.
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='PGsoft slot games' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text Not available bear on any single progreesive jackpot.
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='SimplePlay slot games' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text Not available bear on any jackpot.
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Slot Games Payout Rules' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text For any single bet payout in slot games on the platform, the company will acknowledge a total of MYR 1,000,000 as the final payout.
</template>

<script>

export default {
  components: {
  }
}
</script>